import { render, staticRenderFns } from "./TitleCredits.vue?vue&type=template&id=c265270a&scoped=true&"
import script from "./TitleCredits.vue?vue&type=script&lang=js&"
export * from "./TitleCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c265270a",
  null
  
)

export default component.exports